import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    Validators
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FlowService, SwalService, TranslateService } from '__services';

@Component({
  selector: 'app-flow-reject-modal',
  templateUrl: './flow-reject-modal.component.html',
  styleUrls: ['./flow-reject-modal.component.scss'],
})
export class FlowRejectModalComponent implements OnInit {
  panelForm: FormGroup;
  submittedPanelForm: boolean = false;
  @ViewChild('rejectTemplate') rejectTemplate;
  dialogRef: MatDialogRef<HTMLTemplateElement>;
  @Input() flow: any;
  @Output() rejectSuccess = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    private translationService: TranslateService,
    private flowService: FlowService,
    private dialog: MatDialog
  ) {}

  get cancelled_reason(): AbstractControl {
    return this.panelForm.get('cancelled_reason');
  }

  ngOnInit() {
    this.createPanelForm();
  }

  openDialog() {
    this.dialogRef = this.dialog.open(this.rejectTemplate, { panelClass: 'customise-dialog', width: '750px'});
    this.dialogRef.afterClosed().subscribe(() => {
      this.submittedPanelForm = false;
      this.panelForm.reset();
    });
  }

  createPanelForm(): void {
    const formGroupObj: any = {
      cancelled_reason: [null, [Validators.required]],
    };
    this.panelForm = this.fb.group(formGroupObj);
  }

  getErrorMessage(field: string) {
    switch (field) {
      case 'cancelled_reason':
        return this.translationService.translate('You must enter a value');
    }
  }

  submitPanel(): void {
    this.submittedPanelForm = true;
    if (this.panelForm.invalid) return;
    // const body = this.panelForm.value;
    const body = {
      status: 5,
      remarks: this.panelForm.get('cancelled_reason').value
    };
    this.flowService.updateFlowValidation(body, this.flow.id, '/flows-validate').subscribe(
      (result) => {
        SwalService.success(this.translationService.translate('Reject flow successfully')).then(() => {
          this.rejectSuccess.emit();
        });
        this.dialogRef.close();
      },
      (error) => {
        SwalService.error(error?.message);
      }
    )
  }

}
